import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { marker as _ } from '@jsverse/transloco-keys-manager/marker';
import { catchError, throwError } from 'rxjs';
import { NotificationService } from '../../shared/services/notification.service';
import { AuthService } from '../services/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const notificationService = inject(NotificationService);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        notificationService.showError(_('snackbar.error.sessionExpired'));
        authService.logout();
      } else if (err.status === 403) {
        notificationService.showError(_('snackbar.error.permissionDenied'));
      } else if (err.status === 404) {
        notificationService.showError(_('snackbar.error.loadData'));
      } else if (err.status >= 500) {
        notificationService.showError(_('snackbar.error.internal'));
      }

      return throwError(() => err);
    }),
  );
};
